import {UrlInfo} from "../declarations";
import {findLast} from "lodash";
import {matchPath} from "react-router-dom";

function asUrlInfos<T extends {[key: string]: UrlInfo}>(arg: T): T {
  return arg;
}

export const urls = asUrlInfos({
  home: {
    url: "/",
    path: "/",
    titleKey: "Home",
  },
  dashboard: {
    url: "/dashboard",
    path: "dashboard",
    titleKey: "Dashboard",
  },
  partnerSelector: {
    url: "/partner-selector",
    path: "partner-selector",
    titleKey: "Partner Selector",
  },
  search: {
    url: "/search",
    path: "search",
    titleKey: "Search",
  },
  accountInformation: {
    url: "/account-information",
    path: "account-information",
    titleKey: "Account Information",
  },
  inventory: {
    url: "/inventory",
    path: "inventory",
    titleKey: "Inventory",
  },
  importDirectPayments: {
    url: "/bulk-operations/import-direct-payments",
    path: "bulk-operations/import-direct-payments",
    titleKey: "Import direct payments",
  },
  importRecalls: {
    url: "/bulk-operations/import-recalls",
    path: "bulk-operations/import-recalls",
    titleKey: "Import recalls",
  },
  placeAccounts: {
    url: "/bulk-operations/place-accounts",
    path: "bulk-operations/place-accounts",
    titleKey: "Place accounts",
  },
  reports: {
    url: "/reports",
    path: "reports",
    titleKey: "Reports",
  },
  disputes: {
    url: "/disputes",
    path: "disputes",
    titleKey: "Disputes",
  },
  documentRequests: {
    url: "/document-requests",
    path: "document-requests",
    titleKey: "Document requests",
  },
  // Auth Routes
  auth: {
    url: "/auth",
    path: "auth",
    titleKey: "Auth",
  },
  login: {
    url: "/auth/login",
    path: "login",
    titleKey: "Login",
  },
  forgotPassword: {
    url: "/auth/forgot-password",
    path: "forgot-password",
    titleKey: "Forgot password",
  },
  resetPasswordCode: {
    url: "/auth/reset-password-code",
    path: "reset-password-code",
    titleKey: "Reset password code",
  },
  resetPasswordNew: {
    url: "/auth/reset-password-new",
    path: "reset-password-new",
    titleKey: "Reset password new",
  },
  newPasswordRequired: {
    url: "/auth/new-password",
    path: "new-password",
    titleKey: "New password required",
  },
  // Add more routes as needed
});

export const getUrlInfo = (pathname: string): UrlInfo | undefined => {
  return findLast(urls, (url) => !!matchPath({path: url.url}, pathname));
};
